import { Component, Inject, OnInit } from '@angular/core';
import { ClientManagerInstanceToken, ClientManagerInterface, MaterialModel, MaterialService } from '@evorait/pace-core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';

@Component({
    selector: 'pace-material-history',
    templateUrl: './material-history.component.html',
    styleUrls: ['./material-history.component.scss'],
})
export class MaterialHistoryComponent implements OnInit {
    public materialHistoryList$: Observable<MaterialModel[]>;
    public stringFormat: string;
    public fieldName = 'statusString.value'; // initially materials should be sorted wrt status
    public reverse = false;
    public constructor(
        private readonly materialService: MaterialService,
        public readonly modalInstance: BsModalRef,
        @Inject(ClientManagerInstanceToken) private readonly clientManager: ClientManagerInterface,
    ) {
        this.stringFormat = this.clientManager.getDateFormat();
    }

    public ngOnInit(): void {
        this.materialHistoryList$ = this.materialService.getAllMaterialsOrderedAndRequested();
    }

    public setOrderBy(field: string): void {
        if (this.fieldName === field) {
            this.reverse = !this.reverse;
        } else {
            this.fieldName = field;
        }
    }
}
